import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSE_REQUEST,
	STR_CLOSING_BALANCE,
	STR_COMMISSIONS_REPORT,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_COULD_NOT_FETCH_DATA,
	STR_DATE,
	STR_DISTRICT,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NORMAL_AGENT,
	STR_NOTIFICATIONS,
	STR_PAYABLE,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECEIVABLE,
	STR_RECENT_REQUESTS,
	STR_REGION,
	STR_REPORT_TYPE,
	STR_REPORTS,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SEND_MESSAGE_TO_AGENT,
	STR_SERVICE_PROVIDER,
	STR_STREET,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_SUPER_AGENT,
	STR_TILL_NUMBERS,
	STR_TOTAL_2,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_AGENT_PROFILE,
	STR_WARD,
	STR_YOUR_REQUEST
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdLocationPin, MdMessage, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp, FaUserTag } from "react-icons/fa6";
import { IoPersonSharp } from "react-icons/io5";
import { RiMessage2Line } from "react-icons/ri";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [agentData, setAgentData] = useState(null);
	const [agentReports, setAgentReports] = useState([]);
	const [agentLocation, setAgentLocation] = useState({});


	async function init() {
		//run initializations here
		setReady(false);
		//..
		await Promise.all([
			getAgentData(),
			getAgentReports(),
		])
		setReady(true);
	}

	async function getAgentData() {
		await callApi('get-agent-data', { id }).then((response) => {
			if(response.status === 1) {
				setAgentData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	async function getAgentReports() {
		await callApi('get-all-agent-reports', { agentId: id, }).then((response) => {
			if(response.status === 1) {
				setAgentReports(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	
	useEffect(() => {
		init();
	}, [ id ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		if(agentData) {
			setAgentLocation(JSON.parse(agentData.agentLocation));
		}
	}, [ agentData ])


	if (ready && agentData) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div className="card">
								<div className="card-body text-center">
									<IoPersonSharp size={72} className="text-secondary"/>
									<br/>
									<span
										className="badge bg-dark"
									>
										{agentData.agentType === 'normal_agent' ? STR_NORMAL_AGENT[appContext.language] : ""}
									</span>

									<span
										className="badge bg-primary"
									>
										{agentData.agentType === 'super_agent' ? STR_SUPER_AGENT[appContext.language] : ""}
									</span>

									<h6
										style={{
											fontSize: "24px"
										}}
									>
										{agentData.agentName || agentData.phone}
									</h6>

									{
										(Number(agentData.id) !== Number(appContext.currentUserData.id)) ?
										<RiMessage2Line
											size={32}
											className="mt-2"
											onClick={() => {
												appContext.navTo({
													item: 'view',
													subItem: 'inbox',
													extraItem: agentData.id,
												})
											}}
										/>
										:""
									}
								</div>
							</div>
						</div>

						<div className="col-md-12 mt-3 mb-3">
							<MdLocationPin className="text-muted" size={32}/>

							<div className="row">
								<div className="col-6 col-md-3 mb-2">
									<label className="form-label">{STR_REGION[appContext.language]}</label>
									<h6 style={{ fontSize: "16px" }} className="font-regular">{agentLocation.region || 'N/A'}</h6>
								</div>

								<div className="col-6 col-md-3 mb-2">
									<label className="form-label">{STR_DISTRICT[appContext.language]}</label>
									<h6 style={{ fontSize: "16px" }} className="font-regular">{agentLocation.district || 'N/A'}</h6>
								</div>

								<div className="col-6 col-md-3 mb-2">
									<label className="form-label">{STR_WARD[appContext.language]}</label>
									<h6 style={{ fontSize: "16px" }} className="font-regular">{agentLocation.ward || 'N/A'}</h6>
								</div>

								<div className="col-6 col-md-3 mb-2">
									<label className="form-label">{STR_STREET[appContext.language]}</label>
									<h6 style={{ fontSize: "16px" }} className="font-regular">{agentLocation.street || 'N/A'}</h6>
								</div>

							</div>
						</div>

						<div className="col-md-12">
							<h6
								
								className="mSectionTitle"
							>
								{STR_REPORTS[appContext.language]}
							</h6>
						</div>

						<div className="col-md-12" style={{ overflow: "scroll" }}>
						
							<div
								style={{
									minWidth: "600px",
								}}
							>
								<table
									className="table table-striped"
									style={{ fontSize: "14px" }}
								>
									<thead>
										<tr>
											<th >{STR_DATE[appContext.language]}</th>
											<th >{STR_REPORT_TYPE[appContext.language]}</th>
											<th>{STR_TOTAL_2[appContext.language]}</th>
										</tr>
									</thead>

									<tbody>
										{
											(agentReports && agentReports.length > 0) ?
											agentReports.map((item, i) => {
												return (
													<tr
														key={i}
														onClick={() => {
															appContext.navTo({
																item: 'side-view',
																subItem: 'agent-report',
																extraItem: item.id,
															})
														}}
													>
														<td
														>
															{formatDate(item.dateReported)}
														</td>
														<td
														>
															{(item.reportType === 'closing_balance') ? STR_CLOSING_BALANCE[appContext.language] : ""}
															{(item.reportType === 'commissions') ? STR_COMMISSIONS_REPORT[appContext.language] : ""}
															{(item.reportType === 'receivable') ? STR_RECEIVABLE[appContext.language] : ""}
															{(item.reportType === 'payable') ? STR_PAYABLE[appContext.language] : ""}
														</td>

														
														<td
														>
															{formatMoney(item.totalAmount)} TZS
														</td>
														
													</tr>
												)
											})
											:
											<tr>
												<td>
													{STR_NO_RECORD[appContext.language]}
												</td>
											</tr>
										}
									</tbody>
								</table>
							</div>

						</div>
					</div>
				</div>


			</div>
		)
		
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}